let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let radio = require("ES/lib/radio");
let Modal = require("ES/widgets/Modal");
let esUtils = require("ES/utils/esUtils");
let Constants = require("../../../../../utils/Constants");
let RadioMixin = require("ES/lib/react-pubsub-via-radio.js/RadioMixin");
let esStatusImage = require("../../../calendar_area/esStatusImage");

let CalendarsToCompetitionByDay = function(Calendars, event, dates){
	let competition_by_day = [];
	_.each(dates, function(d){
		let year = d.getFullYear();
		let month = d.getMonth() + 1;
		let date = d.getDate();

		let detail_ids = _.toArray(esUtils.getIn(Calendars, [year, "calendar", year, month, date, "detail_ids"]));

		let items = [];
		_.each(detail_ids, function(detail_id){
			let detail = esUtils.getIn(Calendars, [year, "details", detail_id]);
			if(detail.type === "event" && detail.eid != event.eid){
				let detail_sids = esUtils.cleanup_ids(detail.sids);
				if(_.intersection(detail_sids, event.sids).length > 0){
					items.push(detail);
				}
			}
		});
		competition_by_day.push({date: d, items: items});
	});
	return competition_by_day;
};

module.exports = dd.createClass({
	mixins: [RadioMixin],
	getInitialState(){
		return {competition_by_day: null};
	},
	Radio_setup(){
		return {
			Calendar_get_succeeded(radio_service_key, Calendars){
				let {event} = this.props;
				let dates = this.__getDates();

				this.setState({
					competition_by_day: CalendarsToCompetitionByDay(Calendars, event, dates)
				});
			}
		};
	},
	componentDidMount(){
		let years = _.uniq(_.map(this.__getDates(), function(d){
			return d.getFullYear();
		}));
		_.each(years, function(year){
			radio("Calendar_get").broadcast({year});
		});
	},
	__getDates(){
		let {event} = this.props;

		if(!_.isDate(event.starttime) || !_.isDate(event.stoptime)){
			return [];
		}
		let dates = [new Date(event.starttime.getFullYear(), event.starttime.getMonth(), event.starttime.getDate())];

		let i = 0;//safety belt so there"s no infinite looping
		while((i < 50) && (_.last(dates) < event.stoptime)){
			dates.push(new Date(_.last(dates).getFullYear(), _.last(dates).getMonth(), _.last(dates).getDate() + 1));
			i += 1;
		}
		return dates;
	},
	__openEvent(event_id){
		let {onClose} = this.props;
		return esUtils.wrapPreventDefault(function(){
			onClose();
			radio("Hashbang_set").broadcast("/events/" + event_id);
		});
	},
	render(){
		let {onClose} = this.props;
		let {competition_by_day} = this.state;

		return Modal({
				title: "Hold Competition",
				onClose: onClose
			},
			competition_by_day === null ?
				dd.h4({className: "text-center"}, "Loading...")
				:
				(_.isEmpty(competition_by_day) ?
					"No date range"
					:
					_.map(competition_by_day, function(day, i){
						return dd.div({key: i, style: {marginBottom: competition_by_day.length - 1 === i ? 0 : 20}},
							dd.h3(null, esUtils.format_date(day.date, "dddd, mmmm d, yyyy")),
							_.isEmpty(day.items) ? "(no competition)" : _.map(day.items, function(item, i){
								let priority = _.has(Constants.HOLD_PRIORITY, item.holdPriority) ? Constants.HOLD_PRIORITY[item.holdPriority] : "";
								return dd.div({key: i, style: {marginBottom: 10, lineHeight: "28px"}, className: "clickable", onClick: this.__openEvent(item.eid)},
									dd.div({className: "pull-left", style: {marginRight: 10}},
										esStatusImage({
											status: item.sta,
											delivery_method: item.dm,
											has_parent: item.pntid > 0,
											has_children: item.chd > 0,
											size: 30
										})
									),
									dd.div(null,
										item.desc,
										priority ? " - hold strength " + _.toString(priority).toUpperCase() : null
									),
									dd.div({className: "clearfix"})
								);
							}, this)
						);
					}, this))
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/details/HoldCompetitionModal.js